import { render, staticRenderFns } from "./headerHeader.vue?vue&type=template&id=0c0826f8&scoped=true"
import script from "./headerHeader.vue?vue&type=script&lang=js"
export * from "./headerHeader.vue?vue&type=script&lang=js"
import style0 from "./headerHeader.vue?vue&type=style&index=0&id=0c0826f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0826f8",
  null
  
)

export default component.exports